export class AccesoRequest {
    importe:number;
    email:string;
    documentoCliente:string;
    attribute1: string;
    attribute2: string;
    attribute3: string;
    attribute4: string;
    attribute5: string
    constructor(){
        this.importe=0;
        this.email="";
        this.documentoCliente="";
        this.attribute1="";
        this.attribute2="";
        this.attribute3="";
        this.attribute4="";
        this.attribute5="";
    }
}
